import { useEffect } from 'react';
import { applicaTema } from './ui-theme';
import { usePreferencesStore } from '../store/preferences-store';

/**
 * Porta il tema nel DOM. Stessa forma di `BoardThemeApplier`: una
 * sottoscrizione, un effetto, nessun rendering.
 *
 * Montato in `main.tsx` come FRATELLO di `<App />`, non dentro: `App` e' uno
 * state-router a return anticipati, e il contorno che vive la' dentro sta in una
 * variabile ripetuta a mano trentuno volte (`cookieBanner`, che e' dove
 * `BoardThemeApplier` e' finito). Il tema deve valere su ogni schermata —
 * landing, ospiti, schermata d'errore comprese — e un ramo che se lo dimenticasse
 * non sarebbe un difetto visibile: sarebbe una schermata chiara in mezzo al buio.
 *
 * Il primo disegno non lo fa questo componente: lo fa lo script in `<head>`, che
 * legge la chiave specchio prima che React esista. Qui si riallinea il DOM alla
 * preferenza vera — identica nel caso normale, diversa solo al primo
 * caricamento su un dispositivo nuovo, dove il server dice il buio e lo
 * specchio e' ancora vuoto. Quel ribaltamento e' voluto e documentato in
 * `index.html`.
 */
export default function ThemeApplier(): null {
  const tema = usePreferencesStore((s) => s.uiTheme);

  useEffect(() => {
    applicaTema(tema);
  }, [tema]);

  return null;
}
